import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getVCardByEmployeeID } from '@/modules/VCard/services'
import VCardPublicView from '@/modules/VCard/components/shared/VCardPublicView'
import { normalizeVCardUuid } from '@/modules/VCard/utils/vcard-public'
import { IPermissionProps } from '@/types/shared'
import useAuthStore from '@/stores/useAuthStore'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'

const VCardDetail: React.FC<IPermissionProps> = () => {
    const { employee } = useAuthStore()
    const { t } = useTranslation()
    const navigate = useNavigate()

    const { data, renderState } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.VCARD_CURRENT_EMPLOYEE],
            queryFn: async () => {
                try {
                    return await getVCardByEmployeeID()
                } catch (error) {
                    console.error('Error fetching VCard:', error)
                    return null
                }
            },
            enabled: !!employee,
        },
        {
            loadingComponent: (
                <div className="p-4 flex justify-center">
                    <span>Loading...</span>
                </div>
            ),
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    if (!data?.result) {
        return (
            <div className="text-center p-4">
                <Typogaphy size="small" className="text-gray-500">
                    {t('account-no-information-vcard')}
                </Typogaphy>
            </div>
        )
    }

    const cardUuid = normalizeVCardUuid(data.result.uuid)

    return (
        <div className="w-full p-2">
            <VCardPublicView
                vcard={data!.result}
                uuid={cardUuid}
                mode="preview"
                compact
                showEdit
                onEdit={() => {
                    if (data?.result?.id) {
                        navigate(`/account/vcards/${data.result.id}/edit`)
                    }
                }}
            />
        </div>
    )
}

export default VCardDetail
